<template>
  <div>
    <div v-if="waiter === true">
      <XVwaiter></XVwaiter>
    </div>
    <div v-if="waiter === false">
      <div class="row">
        <div class="col-md-12">
          <span id="lblTitel1" class="titel">{{ translation(15620) }}</span>
        </div>
      </div>
      <div class="row lblinfo">
        <div class="col-md-12">
          <p v-html="translation(15621)"></p>
        </div>
      </div>
      <XVfilter>
        <div slot="content">
          <div class="row margin20">
            <div class="col-md-4">
              <label>{{ translation(15615) }}</label>
            </div>
            <div class="col-md-8">
              <label>{{ translation(15616) }}</label>
            </div>
          </div>
          <XVbootstraprow label :haserror="errors.has('tbxDatumVan')" :errormessage="errors.first('tbxDatumVan')">
            <XVdate
              id="tbxDatumVan"
              name="tbxDatumVan"
              v-model.trim="handelingSettings.istartdate"
              :data-vv-as="translation(15615)"
              v-validate="{ XVDateDefault: true }"
            ></XVdate>
          </XVbootstraprow>

          <div class="row margin20">
            <div class="col-md-offset-4 col-md-8">
              <label>{{ translation(15617) }}</label>
            </div>
          </div>
          <XVbootstraprow label :haserror="errors.has('tbxDatumTot')" :errormessage="errors.first('tbxDatumTot')">
            <XVdate
              id="tbxDatumTot"
              name="tbxDatumTot"
              v-model.trim="handelingSettings.ienddate"
              :data-vv-as="translation(15615)"
              v-validate="{ XVDateDefault: true }"
            ></XVdate>
          </XVbootstraprow>
          <XVbootstraprow :label="translation(15618)">
            <multiselect
              :placeholder="translation(15450)"
              :options="voorbehoudenCategories"
              v-model="handelingSettings.multiselectedVoorbehouden"
              @input="multiselectInputV"
              @close="multiselectCloseV"
              :multiple="true"
              :clear-on-select="false"
              :hide-selected="true"
              :preserve-search="true"
              selectLabel
              label="handelingsName"
              track-by="handelingsName"
              :preselect-first="true"
              :maxHeight="200"
              openDirection="bottom"
              :close-on-select="true"
              :searchable="multiSearchable"
            >
              <template slot="tag" slot-scope="props">
                <span class="multiselect__tag">
                  <span>{{ props.option.handelingsName }}</span>
                  <i
                    aria-hidden="true"
                    tabindex="1"
                    class="multiselect__tag-icon"
                    @click="props.remove(props.option)"
                  ></i>
                </span>
              </template>
              <span slot="noResult">{{ translation(14508) }}</span>
            </multiselect>
          </XVbootstraprow>
          <XVbootstraprow :label="translation(15619)">
            <multiselect
              :placeholder="translation(15450)"
              :options="risicovolleCategories"
              v-model="handelingSettings.multiselectedRisicovolle"
              @input="multiselectInputR"
              @close="multiselectCloseR"
              :multiple="true"
              :clear-on-select="false"
              :hide-selected="true"
              :preserve-search="true"
              selectLabel
              label="handelingsName"
              track-by="handelingsName"
              :preselect-first="true"
              :maxHeight="200"
              openDirection="bottom"
              :close-on-select="true"
              :searchable="multiSearchable"
            >
              <template slot="tag" slot-scope="props">
                <span class="multiselect__tag">
                  <span>{{ props.option.handelingsName }}</span>
                  <i
                    aria-hidden="true"
                    tabindex="1"
                    class="multiselect__tag-icon"
                    @click="props.remove(props.option)"
                  ></i>
                </span>
              </template>
              <span slot="noResult">{{ translation(14508) }}</span>
            </multiselect>
          </XVbootstraprow>
        </div>
        <span slot="filterbuttons">
          <div v-if="!handelingSettings.btnwis">
            <button
              id="btnFilter2"
              :disabled="errors.items.length > 0"
              @click="handelingSettings.btnwis = true"
              class="btn btn-primary XVSearchbarButton"
              @click.prevent="tablefilter()"
            >
              {{ translation(5494) }}
              <font-awesome-icon icon="filter" />
            </button>
          </div>
          <div v-if="handelingSettings.btnwis">
            <div class="btn-group XVSearchbarFilter">
              <button
                id="handelingSettings.btnwis"
                class="btn btn-primary XVSearchbarButton"
                @click.prevent="clearfilter()"
              >
                {{ translation(8835) }}
                <font-awesome-icon icon="eraser" />
              </button>
              <button
                id="btnFilter"
                :disabled="errors.items.length > 0"
                class="btn btn-primary XVSearchbarButton"
                @click.prevent="tablefilter()"
              >
                {{ translation(5494) }}
                <font-awesome-icon icon="filter" />
              </button>
            </div>
          </div>
        </span>
      </XVfilter>
      <XVtableV2
        :filterfunc="filterfunc"
        :tablesetting="handelingTable.tablesetting"
        :tablecolumnsetting="handelingTable.tablecolumnsetting"
        :tabledata="handelingTable.tabledata"
        :rowvisible="handelingTable.rowvisible"
        v-on:sortXVTable="XVTablesort"
        :paging="true"
        :XVtableSetRowStateProperty="XVtableSetRowStateProperty"
      >
        <template slot="dateCompleted" slot-scope="dr">
          <span v-if="dr.row.dateCompleted !== ''">{{ dr.celldata }}</span>
          <span v-if="dr.row.dateCompleted === ''">{{ dr.row.dateStart + ' - ' + dr.row.dateEnd }}</span>
        </template>
        <template slot="handelingsType" slot-scope="dr">
          <span v-if="dr.row.handelingsType === 'R'">{{ translation(15641) }}</span>
          <span v-if="dr.row.handelingsType === 'V'">{{ translation(15642) }}</span>
        </template>
        <template slot="handelingsType_detailrow" slot-scope="dr">
          <div class="row">
            <div class="col-md-4 col-sm-4 col-xs-12">
              <label>{{ translation(15640) }}</label>
            </div>
            <div class="col-md-8 col-sm-8 col-xs-12 form-group">
              <span v-if="dr.row.handelingsType === 'R'">{{ translation(15641) }}</span>
              <span v-if="dr.row.handelingsType === 'V'">{{ translation(15642) }}</span>
            </div>
          </div>
        </template>
      </XVtableV2>
    </div>
  </div>
</template>
<script>
'use strict'

// https://pe.xaurum.nl/peapp/prof/VVNpersonHandelingen
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { FAMixin } from 'pevueglobal'
import { sync } from 'vuex-pathify'
import Multiselect from 'vue-multiselect'

export default {
  mixins: [FAMixin],
  data: function () {
    return {}
  },
  mounted: async function () {
    this.getTexten()
    await this.gethandelingen()
    this.stopLoading()
  },
  computed: {
    ...mapGetters('VVNpersonHandelingen', [
      'voorbehoudenCategories',
      'risicovolleCategories',
      'handelingTable',
      'waiter',
    ]),
    handelingSettings: sync('VVNpersonHandelingen/handelingSettings'),
    multiSearchable: function () {
      if (this.handelingSettings.hasMobile === true) {
        return false
      } else {
        return true
      }
    },
  },
  methods: {
    ...mapActions('VVNpersonHandelingen', ['gethandelingen', 'getTexten']),
    ...mapMutations('VVNpersonHandelingen', ['setHandelingSettings', 'XVTablesort', 'XVtableSetRowStateProperty']),
    multiselectInputV: function (value, id) {
      // Als "all-categorien" is geslecteerd en men selecteerd een echte categorie dan moet "all-categorien" verwijderd worden.
      let alleCategorieen = false
      this.handelingSettings.multiselectedVoorbehouden.forEach((n, i) => {
        if (n.handelingsID === null) {
          alleCategorieen = true // "alle categorieen" staat geselecteerd
        }
      })
      // Als er "geen handeling" is geslecteerd en men selecteerd een echte categorie dan moet "geen handeling" verwijderd worden.
      let geenCategorieen = false
      this.handelingSettings.multiselectedVoorbehouden.forEach((n, i) => {
        if (n.handelingsID === -1) {
          geenCategorieen = true // "geen categorieen" staat geselecteerd
        }
      })
      // Als er meer dan 2 categorieen zijn geselecteerd waarvan "all-categorien" dan deze verwijderen.
      if (this.handelingSettings.multiselectedVoorbehouden.length > 1) {
        if (alleCategorieen === true) {
          this.handelingSettings.multiselectedVoorbehouden.splice(
            0,
            this.handelingSettings.multiselectedVoorbehouden.length - 1
          )
        }
      }
      // Als er meer dan 2 categorieen zijn geselecteerd waarvan "geen-categorien" dan deze verwijderen.
      if (this.handelingSettings.multiselectedVoorbehouden.length > 1) {
        if (geenCategorieen === true) {
          this.handelingSettings.multiselectedVoorbehouden.splice(
            0,
            this.handelingSettings.multiselectedVoorbehouden.length - 1
          )
        }
      }
      // als de geselecteerde categorien worden verwijderd, en er niets zou overblijven, komt altijd "geen-categorien" terug.
      if (this.handelingSettings.multiselectedVoorbehouden.length === 0) {
        this.handelingSettings.multiselectedVoorbehouden.unshift({
          handelingsName: this.translation(15643),
          handelingsID: -1,
          handelingsType: 'V',
        })
      }
    },
    multiselectCloseV: function (value, id) {
      // Bij verlaten categorie filter en er is geen categorie geselecteerd dan op "alle categorien" zetten.
      if (this.handelingSettings.multiselectedVoorbehouden.length === 0) {
        this.handelingSettings.multiselectedVoorbehouden.unshift({
          handelingsName: this.translation(15622),
          handelingsID: null,
          handelingsType: 'V',
        })
      }
    },
    multiselectInputR: function (value, id) {
      // Als "all-categorien" is geslecteerd en men selecteerd een echte categorie dan moet "all-categorien" verwijderd worden.
      let alleCategorieen = false
      this.handelingSettings.multiselectedRisicovolle.forEach((n, i) => {
        if (n.handelingsID === null) {
          alleCategorieen = true // "alle categorieen" staat geselecteerd
        }
      })
      // Als er "geen handeling" is geslecteerd en men selecteerd een echte categorie dan moet "geen handeling" verwijderd worden.
      let geenCategorieen = false
      this.handelingSettings.multiselectedRisicovolle.forEach((n, i) => {
        if (n.handelingsID === -1) {
          geenCategorieen = true // "geen categorieen" staat geselecteerd
        }
      })
      // Als er meer dan 2 categorieen zijn geselecteerd waarvan "all-categorien" dan deze verwijderen.
      if (this.handelingSettings.multiselectedRisicovolle.length > 1) {
        if (alleCategorieen === true) {
          this.handelingSettings.multiselectedRisicovolle.splice(
            0,
            this.handelingSettings.multiselectedRisicovolle.length - 1
          )
        }
      }
      // Als er meer dan 2 categorieen zijn geselecteerd waarvan "geen-categorien" dan deze verwijderen.
      if (this.handelingSettings.multiselectedRisicovolle.length > 1) {
        if (geenCategorieen === true) {
          this.handelingSettings.multiselectedRisicovolle.splice(
            0,
            this.handelingSettings.multiselectedRisicovolle.length - 1
          )
        }
      }
      // als de geselecteerde categorien worden verwijderd, en er niets zou overblijven, komt altijd "all-categorien" terug.
      if (this.handelingSettings.multiselectedRisicovolle.length === 0) {
        this.handelingSettings.multiselectedRisicovolle.unshift({
          handelingsName: this.translation(15644),
          handelingsID: -1,
          handelingsType: 'R',
        })
      }
    },
    multiselectCloseR: function (value, id) {
      // Bij verlaten categorie filter en er is geen categorie geselecteerd dan op "alle categorien" zetten.
      if (this.handelingSettings.multiselectedRisicovolle.length === 0) {
        this.handelingSettings.multiselectedRisicovolle.unshift({
          handelingsName: this.translation(15623),
          handelingsID: null,
          handelingsType: 'R',
        })
      }
    },
    clearfilter: function () {
      this.handelingSettings.multiselectedVoorbehouden.forEach((n, i) => {
        this.handelingSettings.multiselectedVoorbehouden.splice(
          0,
          this.handelingSettings.multiselectedVoorbehouden.length
        )
        this.handelingSettings.multiselectedVoorbehouden.unshift({
          handelingsName: this.translation(15622),
          handelingsID: null,
          handelingsType: 'V',
        })
      })
      this.handelingSettings.multiselectedRisicovolle.forEach((n, i) => {
        this.handelingSettings.multiselectedRisicovolle.splice(
          0,
          this.handelingSettings.multiselectedRisicovolle.length
        )
        this.handelingSettings.multiselectedRisicovolle.unshift({
          handelingsName: this.translation(15623),
          handelingsID: null,
          handelingsType: 'R',
        })
      })
      this.setHandelingSettings({
        istartdate: null,
        ienddate: null,
        zoekDatumVan: null,
        zoekDatumTot: null,
        btnwis: false,
        multiselectedfilterV: this.handelingSettings.multiselectedVoorbehouden,
        multiselectedfilterR: this.handelingSettings.multiselectedRisicovolle,
      })
      // this.tablefilter()
    },
    tablefilter() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.setHandelingSettings({
            zoekDatumVan: this.handelingSettings.istartdate,
            zoekDatumTot: this.handelingSettings.ienddate,
            multiselectedfilterV: this.handelingSettings.multiselectedVoorbehouden,
            multiselectedfilterR: this.handelingSettings.multiselectedRisicovolle,
          })
        }
      })
    },
    filterfunc: function (tabledata) {
      // return tabledata

      let Itabledata = tabledata
      Itabledata = tabledata.filter((n, index) => {
        let van =
          this.handelingSettings.zoekDatumVan === null || new Date(n.dateSort) >= this.handelingSettings.zoekDatumVan
        let tot =
          this.handelingSettings.zoekDatumTot === null || new Date(n.dateSort) <= this.handelingSettings.zoekDatumTot

        let multiV
        multiV =
          this.handelingSettings.multiselectedfilterV.find(
            (m) =>
              m.handelingsID === n.handelingsID ||
              m.handelingsID === null ||
              (m.handelingsType !== n.handelingsType && m.handelingsID !== n.handelingsID)
          ) !== undefined

        let multiR =
          this.handelingSettings.multiselectedfilterR.find(
            (m) =>
              m.handelingsID === n.handelingsID ||
              m.handelingsID === null ||
              (m.handelingsType !== n.handelingsType && m.handelingsID !== n.handelingsID)
          ) !== undefined
        return van && tot && multiV && multiR
      })
      return Itabledata
    },
  },
  components: {
    Multiselect,
  },
}
</script>
<style></style>
